export default {
  TOGGLE_BUG_REPORT_DIALOG: (state, payload) => {
    state.bugReportDialog = payload;
  }
};